var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticStyle:{"flex":"0 0 20px"}},[_c('strong',[_vm._v(_vm._s(_vm.object.quantity === 0 ? _vm.$t('share.no') : _vm.object.quantity))])]),_c('span',{style:(("background: " + _vm.spanBg + "; border-radius: 8px; color: white; padding: 8px 8px; margin: auto 4px; font-weight: 700;"))},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('span',{domProps:{"innerHTML":_vm._s(
      _vm.object.quantity === 0
        ? _vm.$t('leadWeekly.intro.noLeads')
        : _vm.$t('leadWeekly.intro.leads', {
            value: _vm.numberFormat({
              number: _vm.object.amount,
              style: 'currency',
              currency: _vm.object.currency,
              notation: 'compact',
            }),
          })
    )}})])}
var staticRenderFns = []

export { render, staticRenderFns }